import { isBrowser } from '@snapchat/mw-common/client';

export { isBrowser };

// eslint-disable-next-line no-restricted-syntax
export const isSSR = (): boolean => !isBrowser();
